// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteSafetyAnchorPointRequestModel from '../../model/delete-safety-anchor-point-request-model';
import DeleteSafetyAnchorPointRequestDTO from '../dto/delete-safety-anchor-point-request-dto';
import dtoSchema from '../schemas/delete-safety-anchor-point-request-schema';

export default abstract class DeleteSafetyAnchorPointRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteSafetyAnchorPointRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteSafetyAnchorPointRequestDTO>): DeleteSafetyAnchorPointRequestModel;
  static toModel(dto: DeepPartial<DeleteSafetyAnchorPointRequestDTO> | undefined | null): DeleteSafetyAnchorPointRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteSafetyAnchorPointRequestDTO> | undefined | null): DeleteSafetyAnchorPointRequestModel | undefined {
    return dto ? new DeleteSafetyAnchorPointRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteSafetyAnchorPointRequestModel> | DeleteSafetyAnchorPointRequestModel): DeleteSafetyAnchorPointRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteSafetyAnchorPointRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteSafetyAnchorPointRequestModel, can not map to DeleteSafetyAnchorPointRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
